module.exports = __webpack_public_path__ + "static/key-theuncertainlastquietday-ee5f79c394a6d85713a89980ef17b23f.webp";